import React, { Component } from "react"
import "./Popup.scss"

class Popup extends Component {
    closePopup()    {
        window.location.reload();
    }
    render() {
        return (
            <div style={{ display: (this.props.isPopupActive ? "block" : "none") }}>
                <div className="popupfade" onClick={this.closePopup}></div>
                <section className="section section-popup">
                    <div className="padding">
                        <div className="container">
                            <div className="close" onClick={this.closePopup}>
                                <i aria-hidden="true" className="fa fa-close fa-2x"></i>
                            </div>
                            <div className="thanks">
                                <div className="text">
                                    <span>תודה.</span><br/>
                                    בהחלט סיפקתם למאמן חומר למחשבה
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default Popup


// WEBPACK FOOTER //
// ./src/Components/Popup/Popup.jsx